<div class="terms-and-conditions wrapper--spacing-horizontal">
  <div class="terms-and-conditions__header">
    <h1 class="text--h1">{{ 'terms-and-conditions.title' | translate }}</h1>
    <p>{{ 'terms-and-conditions.subtitle' | translate }}</p>
  </div>

  <div class="terms-and-conditions__body">
    <h2 class="text--h2">{{ 'terms-and-conditions.general-terms-and-conditions' | translate }}</h2>
    <a [href]="'generalTermsAndConditions' | localizedLinkPipe" target="_blank">{{ 'terms-and-conditions.general-terms-and-conditions' | translate }}</a>

    <h2 class="text--h2">{{ 'terms-and-conditions.order-and-delivery-conditions' | translate }}</h2>

    <div class="delivery-conditions-container">
      <a *ngIf="'deliveryConditionsRumimants' | localizedLinkPipe" [href]="'deliveryConditionsRumimants' | localizedLinkPipe" target="_blank">{{
        'terms-and-conditions.delivery-conditions-links.ruminants' | translate
      }}</a>
      <a *ngIf="'deliveryConditionsPoultry' | localizedLinkPipe" [href]="'deliveryConditionsPoultry' | localizedLinkPipe" target="_blank">{{
        'terms-and-conditions.delivery-conditions-links.poultry' | translate
      }}</a>
      <a *ngIf="'deliveryConditionsPigs' | localizedLinkPipe" [href]="'deliveryConditionsPigs' | localizedLinkPipe" target="_blank">{{
        'terms-and-conditions.delivery-conditions-links.pigs' | translate
      }}</a>
      <a *ngIf="'deliveryConditionsPlant' | localizedLinkPipe" [href]="'deliveryConditionsPlant' | localizedLinkPipe" target="_blank">{{
        'terms-and-conditions.delivery-conditions-links.plant' | translate
      }}</a>
      <a *ngIf="'belgiumContactAndLocations' | localizedLinkPipe" [href]="'belgiumContactAndLocations' | localizedLinkPipe" target="_blank">{{
        'terms-and-conditions.delivery-conditions-links.contactAndLocation' | translate
      }}</a>
    </div>
  </div>
</div>
